import request from "@/api/request"

// 查询校区列表
export function listOrganization(query) {
  return request({
    url: '/organization/list',
    method: 'get',
    params: query
  })
}

// 查询校区详细
export function getOrganization(id) {
  return request({
    url: '/organization/' + id,
    method: 'get'
  })
}

// 新增校区
export function addOrganization(data) {
  return request({
    url: '/organization/add',
    method: 'post',
    data: data
  })
}

// 修改校区
export function updateOrganization(data) {
  return request({
    url: '/organization/edit',
    method: 'post',
    data: data
  })
}

// 删除校区
export function delOrganization(id) {
  return request({
    url: '/organization/' + id,
    method: 'delete'
  })
}

// 获取所有机构
export function orgList() {
  return request({
    url: '/organization/getAll'
  })
}
